import { Actions, Badge, Image } from "@";
import { useCanShow } from "@/shared/hooks";
import {
  cardFloatChip,
  cardFooter,
  cardMedia,
  cardMediaImg,
  cardOverlayTitle,
  cardScrim,
  cardSkeletonBlock,
  cardSkeletonSurface,
  cardSurface,
} from "../../shared/cards";
import type { CarouselItem } from "../types";

interface BannerImageProps {
  src?: string | null;
  alt?: string | null;
}

const BannerImage = ({ src, alt }: BannerImageProps) => {

  return (
    <div className={`${cardMedia} `}>
      <Image
        click={() => {}}
        className={cardMediaImg}
        src={src}
        alt={alt}
        size="500"
      />

      {/* Bottom scrim so the overlaid title stays legible on any image */}
      <span aria-hidden className={cardScrim} />
    </div>
  );
};

interface CarouselCardProps {
  item: CarouselItem;
  onEdit: (item: CarouselItem) => void;
  deleteHandler: (id: number) => Promise<void> | void;
}

export const CarouselCard = ({
  item,
  onEdit,
  deleteHandler,
}: CarouselCardProps) => {
  const canEdit = useCanShow("editMainBanner");
  const active = item.isActive;

  return (
    <article className={cardSurface}>
      <div className="relative">
        <BannerImage src={item.imageUrl} alt={item.title} />

        {/* Order chip — top start */}
        <span className={`absolute start-3 top-3 ${cardFloatChip}`}>
          #{item.order ?? 0}
        </span>

        {/* Status pill — top end */}
        <span className="absolute end-3 top-3 inline-flex items-center">
          <Badge
            color={active ? "green" : "red"}
            title={active ? "مفعل" : "غير مفعل"}
          />
        </span>

        {/* Title overlaid on the scrim */}
        <h3 className={cardOverlayTitle}>{item.title || "بدون عنوان"}</h3>
      </div>

      {canEdit && (
        <div className={`${cardFooter} justify-center`}>
          <Actions notShow row={item} edit={onEdit} delete={deleteHandler} />
        </div>
      )}
    </article>
  );
};

export const CarouselCardSkeleton = () => (
  <div className={cardSkeletonSurface}>
    <div className="aspect-[16/7] w-full animate-pulse bg-gray-200 dark:bg-gray-700" />
    <div className="flex items-center justify-center gap-2 border-t border-gray-100 px-3 py-3 dark:border-gray-700/60">
      <span className={`h-9 w-28 ${cardSkeletonBlock} rounded-2xl`} />
    </div>
  </div>
);
